module.exports = __webpack_public_path__ + "img/statistics-h.24410a12.svg";